import React, { Component } from "react";

import style from "./RegistrationPage.module.css";

import logo from "../../assets/Images/logo.png";

import GymRegistrationForm1 from "../../Container/GymRegistration/GymRegistrationPersonalInfoForm";
import AthleteRegistrationForm from "../../Container/AthleteRegistration/AthleteRegistrationForm";

import { BrowserRouter as Router, withRouter } from "react-router-dom";
import { marketPlaceParam } from "../../assets/Js/paramName";

const paramEnum = {
  gym: "gymaccount",
  athlete: "athleteaccount",
  login: "login",
};

export default withRouter(
  class RegistrationPage extends Component {
    constructor(props) {
      super(props);

      this.state = {
        paramType: "",
        athleteFormResult: false,
        queryParams: "",
        infoBox: false,
        gymName: "",
        trackName: "",
      };

      this.setState = this.setState.bind(this);
    }

    componentDidMount() {
      let id = this.props.match.params.id;

      const paramName = marketPlaceParam;
      const search = this.props.location.search;
      const paramValue = new URLSearchParams(search).get(paramName);
      const gymName = new URLSearchParams(search).get("gymname");
      const trackName = new URLSearchParams(search).get("trackname");

      let isRequiredParams = false;
      isRequiredParams =
        search.includes("?" + paramName + "=") ||
        search.includes("&" + paramName + "=");

      this.setState({
        paramType: id,
        queryParams: search,
        infoBox: isRequiredParams,
        gymName,
        trackName,
      });
    }

    whereToRedirect = () => {
      const { paramType, queryParams } = this.state;

      if (queryParams) {
        if (paramType === paramEnum.login) {
          this.gotoToSpecificRoute(`/login${queryParams}`);
        } else if (paramType === paramEnum.gym) {
          this.gotoToSpecificRoute(
            `/registrationform/${paramType}${queryParams}`
          );
        } else if (paramType === paramEnum.athlete) {
          this.gotoToSpecificRoute(
            `/registrationform/${paramType}${queryParams}`
          );
        }
      } else {
        if (paramType === paramEnum.login) {
          this.gotoToSpecificRoute("/login");
        } else {
          this.gotoToSpecificRoute(`/registrationform/${paramType}`);
        }
      }
    };

    gotoToSpecificRoute = (route) => {
      this.props.history.push(route);
    };

    setParam = (_paramType) => {
      this.setState(
        {
          paramType: _paramType,
        },
        () => {
          this.whereToRedirect();
        }
      );
    };

    render() {
      return (
        <>
          <div className={`${style.container} pt-3 pb-3`}>
            <div className="cornerBtnStyle">
              <button
                className="basicBtnStyle secondaryBtn"
                onClick={() => this.setParam(paramEnum.login)}
              >
                Login
              </button>
            </div>
            <div className={`${style.formContainer} shadow`}>
              {this.state.infoBox && (
                <div
                  class="alert alert-success alert-dismissible fade show mr-3 ml-4 mb-0 mt-3"
                  role="alert"
                >
                  To continue joining
                  <strong>{`${this.state.gymName && this.state.trackName ? `your
                    ${this.state.gymName}'s ${this.state.trackName}
                  `:'' }
                 `}</strong>please register!
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              )}
              <div className="logo">
                <img src={logo} className="w-100" />
              </div>
              <hr className="m-0" />
              {this.state.paramType === "athleteaccount" ? (
                <AthleteRegistrationForm
                  setNextPage={this.setState}
                  queryParams={this.state.queryParams}
                />
              ) : this.state.paramType === "gymaccount" ? (
                <GymRegistrationForm1 queryParams={this.state.queryParams} />
              ) : null}
              {this.state.athleteFormResult
                ? this.props.history.push("/athleteaccountform2")
                : null}
            </div>
          </div>
        </>
      );
    }
  }
);
